import React from 'react';
import { RushLeaderboardEntry } from '../../types/triviaRush';

const MEDALS: Record<number, string> = { 1: '\u{1F947}', 2: '\u{1F948}', 3: '\u{1F949}' };
const MEDAL_COLORS: Record<number, string> = { 1: '#FFD700', 2: '#C0C0C0', 3: '#CD7F32' };

interface Props {
  entry: RushLeaderboardEntry;
  isBlurred?: boolean;
}

export const RushLeaderboardRow: React.FC<Props> = ({ entry, isBlurred }) => {
  const medal = MEDALS[entry.rank];
  const medalColor = MEDAL_COLORS[entry.rank];

  return (
    <div
      className="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors"
      style={{
        backgroundColor: entry.is_current_user
          ? 'rgba(139, 92, 246, 0.15)'
          : 'var(--rush-bg-card)',
        border: entry.is_current_user
          ? '1px solid rgba(139, 92, 246, 0.3)'
          : '1px solid var(--rush-border)',
        boxShadow: entry.is_current_user ? 'var(--rush-shadow-glow)' : undefined,
      }}
    >
      {/* Rank */}
      <div className="w-8 text-center shrink-0">
        {medal ? (
          <span className="text-lg">{medal}</span>
        ) : (
          <span
            className="text-sm font-mono font-bold"
            style={{ color: 'var(--rush-text-muted)' }}
          >
            {entry.rank}
          </span>
        )}
      </div>

      {/* Username + Institution */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5">
          <span
            className="text-sm font-medium truncate"
            style={{
              color: medalColor || 'var(--rush-text-primary)',
              filter: isBlurred ? 'blur(4px)' : undefined,
            }}
          >
            {entry.username}
          </span>
          {entry.institution_name && (
            <span
              className="shrink-0 inline-flex items-center gap-1 text-[10px] font-medium px-1.5 py-0.5 rounded-full"
              style={{
                backgroundColor: 'rgba(139, 92, 246, 0.15)',
                color: 'var(--rush-purple-soft)',
              }}
            >
              {entry.institution_logo_url && (
                <img
                  src={entry.institution_logo_url}
                  alt=""
                  loading="lazy"
                  className="w-3.5 h-3.5 rounded-full object-contain"
                />
              )}
              {entry.institution_name}
            </span>
          )}
        </div>
      </div>

      {/* Score */}
      <div className="shrink-0">
        <span
          className="text-base font-mono font-bold"
          style={{
            color: 'var(--rush-purple-accent)',
            filter: isBlurred ? 'blur(4px)' : undefined,
          }}
        >
          {isBlurred ? '???' : entry.highest_streak}
        </span>
      </div>
    </div>
  );
};
